import { Add } from "@mui/icons-material";
import PaperButton from "components/buttons/PaperButton";
import { ERR_NETWORK } from "constants/messages";
import { serverPost } from "lib/serverRequest";
import { getPies } from "models/piesModel";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { arrayMove } from "react-sortable-hoc";
import { openLoading } from "store/reducers/tools";
import FlavoursTable from "./forms/FlavoursTable";

export default function FlavoursComponent() {
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);

  const loadData = () => {
    openLoading(true);
    getPies({
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          if (!res && err?.message) {
            enqueueSnackbar(err?.message, { variant: "warning" });
          } else {
            enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
          }
          return;
        }
        setData(res);
      },
    });
  };

  const handleAdd = () => {
    history.push("/flavours/add");
  };

  const handleSort = (oldIndex = 0, newIndex = 0) => {
    setData((prev) => {
      serverPost({
        url: "pie/updateOrder",
        data: { pies: arrayMove(prev, oldIndex, newIndex)?.slice() },
      });
      return arrayMove(prev, oldIndex, newIndex)?.slice();
    });
  };

  const handleView = (value = {}, valueIndex) => {
    dispatch({ type: "SET_APP", payload: { flavorData: value } });
    history.push("/flavours/update");
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="flex justify-end mb-4">
        <PaperButton
          onClick={handleAdd}
          icon={<Add className="text-light-gray" />}
        >
          Add New Flavour
        </PaperButton>
      </div>
      <FlavoursTable
        data={data ?? []}
        onChange={setData}
        onView={handleView}
        onSortEnd={handleSort}
      />
    </div>
  );
}
